import Vue from 'vue'
import Vuex from 'vuex'
import qs from 'qs'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
// console.log(apiUrl)

export default new Vuex.Store({
  strict: debug,

  state: {
    // Add url
    // apiUrl: 'http://localhost:3001/api/',
    apiUrl: '/api/',
    // apiUrl: 'http://159.65.33.26:3001/api/',
    // apiUrl: 'https://159.65.33.26:3001/api/',
    viewerStaticUrl: '/static/output/',

    practiceAreas: [],
    formRoles: [],
    forms: [],
    currentTemplateName: 'default',
    currentFormId: null,
    templates: {},
    questionnaires: {},
    models: [],
    widgets: [],

    roleTreeData: {},

    pageScale: 1,
    pageWidth: 612,
    pageHeight: 792,
    fontSize: 12,
    fileCurrentPage: 1,
    totalPages: 0,
    outputPath: '',
    annotations: [],
    lastSaved: 0,
    currentLocale: 'en',

    editingFields: false,
    drawingAnnotation: false,
    dragIndex: false,
    multipleSelect: false,
    disablePageNavigation: false,
    assigningIndexes: false,
    showFields: false,
    showPageList: false,
    showAnnotationMenu: false,
    showBottomMenu: true,
    showAnnotations: false,
    selectedQuestionnaireField: '',

    abFieldsWatcher: [],

    autofillDetails: null,
    autofillId: null,

    officialModels: null,
    allOfficialModels: null,

    allFilters: [],

    user: {
      email: null,
      accessToken: null
    }
  },

  actions: {
    applyTemplate ({commit, state}) {
      // let invalidFields = []
      // if (typeof state.templates[state.currentTemplateName]['pages'] === 'undefined' || !Object.keys(state.templates[state.currentTemplateName]['pages']).length) return true

      // for (const page in state.templates[state.currentTemplateName]['pages']) {
        // if (state.currentTemplate['pages'].hasOwnProperty(page)) {
          // const pageFields = state.currentTemplate['pages'][page]
          // pageFields.forEach(field => {

          //   if (typeof state.documentFields[page]['pageFields'][field.id] === 'undefined') {
          //     invalidFields.push(field.id)
          //     return
          //   } else {
          //     let fieldData = JSON.parse(JSON.stringify(state.documentFields[page]['pageFields'][field.id]))
          //     Object.assign(fieldData, field)

          //     commit('setDocumentPageField', {
          //       id: field.id,
          //       page: page,
          //       data: fieldData
          //     })

          //     if (page === state.fileCurrentPage) {
          //       commit('setField', {
          //         id: field.id,
          //         data: fieldData
          //       })
          //     }
          //   }
          // })
        // }
      // }

      // if (invalidFields.length) return false
      return true
    },

    getFormList ({commit, state}, data) {
      const apiUrl = state.apiUrl

      return Vue.axios.post(apiUrl + 'form/list', {
        data: data
      }).then(response => response.data)
    },

    createFieldGroup ({commit, state}, data) {
      commit('addFieldGroup', data)
    },

    createCheckboxGroup ({commit, state}, data) {
      commit('addCheckboxGroup', data)
    },

    saveTemplatePages ({commit, state}) {
      const apiUrl = state.apiUrl

      let pages = state.templates[state.currentTemplateName]['pages']

      const postData = {
        templateId: state.templates[state.currentTemplateName]['_id'],
        newData: pages
      }

      Vue.axios.post(apiUrl + 'template/update-pages', postData).then(response => {
        if (response.data.success) {
          window.vueBus.emit('addNotification', {
            title: 'Templates Saved',
            body: 'All templates were saved successfully',
            type: 'success'
          })
        } else {
          window.vueBus.emit('addNotification', {
            title: 'Template Save Error',
            body: 'There was an error updating the template. Please review the data and try again',
            type: 'error'
          })
        }
      })
      commit('setLastSaved', Date.now())
    },

    saveTemplate ({commit, state}) {
      const apiUrl = state.apiUrl

      let currentPage = state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage]

      const postData = {
        templateId: state.templates[state.currentTemplateName]['_id'],
        page: state.fileCurrentPage,
        newData: currentPage,
        checkboxGroups: state.templates[state.currentTemplateName]['checkboxGroups'],
        chGroups: state.templates[state.currentTemplateName]['chGroups'],
        widgetLabels: state.templates[state.currentTemplateName].widgetLabels !== undefined ? state.templates[state.currentTemplateName].widgetLabels : {}
      }

      Vue.axios.post(apiUrl + 'template/update-field', postData).then(response => {
        if (response.data.success) {
          window.vueBus.emit('addNotification', {
            title: 'Templates Saved',
            body: 'All templates were saved successfully',
            type: 'success'
          })
        } else {
          window.vueBus.emit('addNotification', {
            title: 'Template Save Error',
            body: 'There was an error updating the template. Please review the data and try again',
            type: 'error'
          })
        }
      })
      commit('setLastSaved', Date.now())
    },

    resetIndexes ({commit, state}) {
      commit('resetTabOrders')
      return true
    },

    // GET AUTOFILL

    getAutofill ({ commit, state }, formId) {
      return Vue.axios.get(
        state.apiUrl + 'autofill/form-id/?formId=' + formId
      ).then(response => response)
        .catch(error => error)
    },

    // INSERT AUTOFILL

    addAutofill ({ commit, state }, autofill) {
      return Vue.axios.post(
        state.apiUrl + 'autofill/add', autofill
      ).then(response => response)
        .catch(error => error)
    },

    // UPDATE AUTOFILL

    updateAutofill ({ commit, state }, payload) {
      return Vue.axios.post(
        state.apiUrl + 'autofill/update', payload
      ).then(response => response)
        .catch(error => error)
    },

    // GET AUTOFILL DETAILS

    getAutofillDetails ({ commit, state }, autofillId) {
      commit('setAutofillId', autofillId)

      return Vue.axios.get(
        state.apiUrl + 'autofillDetails/autofill-id/?autofillId=' + autofillId
      ).then(response => {
        commit('setAutofillDetails', response.data)
      }).catch(error => error)
    },

    // INSERT AUTOFILL DETAILS

    addAutofillDetail ({ commit, state }, autofillDetail) {
      return Vue.axios.post(
        state.apiUrl + 'autofillDetails/add', autofillDetail
      ).then(response => response)
        .catch(error => error)
    },

    // UPDATE AUTOFILL DETAILS

    updateAutofillDetail ({ commit, state }, payload) {
      return Vue.axios.post(
        state.apiUrl + 'autofillDetails/update', payload
      ).then(response => response)
        .catch(error => error)
    },

    // UPDATE AUTOFILL DETAILS

    deleteAutofillDetails ({ commit, state }, payload) {
      return Vue.axios.post(
        state.apiUrl + 'autofillDetails/delete', payload
      ).then(response => response)
        .catch(error => error)
    },

    // DELETE ONE AUTOFILLDETAILL

    deleteAutofillDetail ({ commit, state }, payload) {
      return Vue.axios.delete(
        state.apiUrl + 'autofillDetail/delete-one/' + payload.autofillDetailId
      ).then(response => response)
        .catch(error => error)
    },

    // GET TEMPLATES

    getTemplates ({ commit, state }, formId) {
      return Vue.axios.get(
        state.apiUrl + 'template/list/' + formId
      ).then(response => response)
        .catch(error => error)
    },

    deleteOldTemplates ({ commit, state }, formId) {
      return Vue.axios.post(
        state.apiUrl + 'template/delete-default/' + formId
      ).then(response => response)
        .catch(error => error)
    },

    uploadTemplate ({ commit, state }, globalTemplate) {
      return Vue.axios.post(
        state.apiUrl + 'template/add', globalTemplate
      ).then(response => response)
        .catch(error => error)
    },

    uploadDefaultQuestionnaire ({ commit, state }, templateId) {
      return Vue.axios.post(
        state.apiUrl + 'questionnaire/add', { templateId: templateId }
      ).then(response => response)
        .catch(error => error)
    },

    // GET QUESTIONNAIRES

    getQuestionnaire ({ commit, state }, templateId) {
      return Vue.axios.get(
        state.apiUrl + 'questionnaire/list/' + templateId
      ).then(response => response)
        .catch(error => error)
    },

    // DELETE QUESTIONNAIRE

    deleteQuestionnaire ({ commit, state }, questionnaireId) {
      return Vue.axios.post(
        state.apiUrl + 'questionnaire/delete/' + questionnaireId
      ).then(response => response)
        .catch(error => error)
    },

    // GET OFFICIAL MODEL

    getOfficialModel ({ commit, state }) {
      let modelList = state.autofillDetails.map(a => a.model)

      return Vue.axios.post(
        state.apiUrl + 'official-model/find-list/', { modelList }
      ).then(response => {
        commit('setOfficialModels', response.data)
      })
        .catch(error => error)
    },

    // GET OFFICIAL MODEL

    getAllOfficialModels ({ commit, state }) {
      return Vue.axios.get(
        state.apiUrl + 'official-model/list/'
        ).then(response => {
          commit('setAllOfficialModels', response.data)
        })
        .catch(error => error)
    },

    // DID YOU MEAN OFFICIAL MODEL

    didYouMeanOfficialModel ({ commit, state }, model) {
      return Vue.axios.get(
        state.apiUrl + 'official-model/did-you-mean/?model=' + model
      ).then(response => response)
        .catch(error => error)
    },

    // INSERT OFFICIAL MODEL

    addOfficialModel ({ commit, state }, newOfficialModel) {
      return Vue.axios.post(
        state.apiUrl + 'official-model/add', newOfficialModel
      ).then(response => {
        if (response.data.success === true) {
          commit('setAllOfficialModels', response.data.list)
        }
      })
        .catch(error => error)
    },

    // INSERT BARCODE TEMPLATE

    addBarcodeTemplate ({ commit, state }, barcodeTemplate) {
      return Vue.axios.post(
        state.apiUrl + 'barcode/add', barcodeTemplate
      ).then(response => response)
        .catch(error => error)
    },

    // GET BARCODE TEMPLATE FOR FORMID

    getListBarcodeTemplate ({ commit, state }) {
      return Vue.axios.get(
        state.apiUrl + 'barcode/list/?formId=' + state.templates[state.currentTemplateName].formId
      ).then(response => response)
        .catch(error => error)
    },

    // GET BARCODE TEMPLATE FOR _ID

    getBarcodeTemplate ({ commit, state }, barcodeId) {
      return Vue.axios.get(
        state.apiUrl + 'barcode/' + barcodeId
      ).then(response => response)
        .catch(error => error)
    },

    // UPDATE BARCODE TEMPLATE FOR _ID

    updateBarcodeTemplate ({ commit, state }, barcodeTemplate) {
      return Vue.axios.post(
        state.apiUrl + 'barcode/update', barcodeTemplate
      ).then(response => response)
        .catch(error => error)
    },

    // DELETE BARCODE TEMPLATE

    deleteBarcodeTemplate ({ commit, state }, barcodeId) {
      return Vue.axios.post(
        state.apiUrl + 'barcode/delete/' + barcodeId
      ).then(response => response)
        .catch(error => error)
    },

    // GET FORM TAGS
    getFormTags ({ commit, state }, payload) {
      return Vue.axios.get(
        state.apiUrl + 'form/tags/?tagType=' + payload.tagType
      ).then(response => response)
        .catch(error => error)
    },

    // ADD ROLES

    addRole ({ commit, state }, newRole) {
      return Vue.axios.post(
        state.apiUrl + 'role/add', newRole
      ).then(response => response)
        .catch(error => error)
    },

    // UPDATE ROLES

    updateRole ({ commit, state }, payload) {
      return Vue.axios.post(
        state.apiUrl + 'role/update', payload
      ).then(response => response)
        .catch(error => error)
    },

    // ADD MODEL

    addModel ({ commit, state }, newModel) {
      return Vue.axios.post(
        state.apiUrl + 'model/add', newModel
      ).then(response => response)
        .catch(error => error)
    },

    // UPDATE MODELS

    updateModel ({ commit, state }, payload) {
      return Vue.axios.post(
        state.apiUrl + 'model/update', payload
      ).then(response => response)
        .catch(error => error)
    },

    // UPDATE FORM

    updateForm ({ commit, state }, payload) {
      return Vue.axios.post(
        state.apiUrl + 'form/update', qs.parse(payload.formData)
      ).then(response => response)
        .catch(error => error)
    },

    // Validate Token

    validateAccessToken ({commit, state}, accessToken) {
      return Vue.axios.post(state.apiUrl + 'validate-kento', {
        accessToken: accessToken
      }).then(response => response.data)
    },

    // Get Official Models Modal
    getOfficialModelsList ({commit, state}, data) {
      const apiUrl = state.apiUrl

      return Vue.axios.post(apiUrl + 'official-model/list-j', {
        data: data
      }).then(response => response.data)
    }
  },

  mutations: {
    setAllFilters: (state, payload) => {
      state.allFilters = payload.filters
    },

    setBlankFilters: (state, payload) => {
      state.allFilters = []
    },

    setOfficialModel: (state, payload) => {
      state.templates[state.currentTemplateName].pages[payload.page].forEach((field, index) => {
        if (payload.fieldId === field.id) {
          state.templates[state.currentTemplateName].pages[payload.page][index].model = payload.model
        }
      })
    },

    setAllOfficialModels (state, officialModels) {
      state.allOfficialModels = officialModels
    },

    setOfficialModels (state, officialModels) {
      state.officialModels = officialModels
    },

    setAutofillId (state, autofillId) {
      state.autofillId = autofillId
    },

    setAutofillDetails (state, data) {
      state.autofillDetails = data
    },

    setPagesTemplate (state, pages) {
      state.templates[state.currentTemplateName].pages = pages
    },

    setModelsAutofillDetails (state) {
      let pages = state.templates[state.currentTemplateName]['pages']
      state.templates[state.currentTemplateName]['pages'] = {}

      Object.keys(pages).forEach((pageKey, indexPage) => {
        if (pages[pageKey] === null) return

        pages[pageKey].forEach((field, index) => {
          if (field === null || field.id === undefined) return

          let pdfFieldName = field.id.replace(/]_/g, '].')
          pages[pageKey][index].model = ''

          if (state.autofillDetails.map(a => a.pdfField).indexOf(pdfFieldName) !== -1) {
            pages[pageKey][index].model = state.autofillDetails[state.autofillDetails.map(a => a.pdfField).indexOf(pdfFieldName)].model
          }
        })

        if (Object.keys(pages).length === (indexPage + 1)) {
          state.templates[state.currentTemplateName]['pages'] = pages
        }
      })
    },

    setRoleTreeData (state, data) {
      state.roleTreeData = data
    },

    addField (state) {
      const fieldId = 'newField-' + Date.now()
      let tmp = state.templates
      tmp[state.currentTemplateName]['pages'][state.fileCurrentPage].push({
        width: 50,
        height: 50,
        x: 50,
        y: 50,
        tabOrder: -1,
        maskType: '',
        id: fieldId,
        name: fieldId,
        model: '',
        type: 'text',
        fieldPage: state.fileCurrentPage
      })

      state.templates = tmp
    },

    deleteForm (state, formId) {
      let tmp = state.forms
      let deleteIndex = null
      for (let i = 0; i < tmp.length; i++) {
        if (tmp[i]['_id'] === formId) {
          deleteIndex = i
          i = tmp.length + 1
        }
      }
      tmp.splice(deleteIndex, 1)
      state.forms = tmp
    },

    updateForm (state, formData) {
      let tmp = state.forms
      let updateIndex = null
      for (let i = 0; i < tmp.length; i++) {
        if (tmp[i]['_id'] === formData.formId) {
          updateIndex = i
          i = tmp.length + 1
        }
      }
      if (updateIndex !== null) {
        formData.newData['_id'] = formData.formId
        Vue.set(tmp, updateIndex, formData.newData)
        state.forms = tmp
      }
    },

    deleteField (state, fieldIndex) {
      let tmp = state.templates
      Vue.delete(tmp[state.currentTemplateName]['pages'][state.fileCurrentPage], fieldIndex)
      state.templates = tmp
    },

    resetTabOrders (state) {
      let tmp = state.templates
      tmp[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach((field, index) => {
        tmp[state.currentTemplateName]['pages'][state.fileCurrentPage][index]['tabOrder'] = -1
      })
      state.templates = tmp
    },

    setModels (state, models) {
      state.models = models
    },

    setAbFieldWatcher (state, payload) {
      if (payload === undefined) return

      payload.forEach(abFieldWatcher => {
        let abWatcher = {
          label: abFieldWatcher
        }

        if (state.abFieldsWatcher.map(a => a.label).indexOf(abFieldWatcher) === -1) state.abFieldsWatcher.push(abWatcher)
      })
    },

    resetAbFieldsWatcher (state) {
      state.abFieldsWatcher = []
    },

    setSelectedQuestionnaireField (state, fielName) {
      Object.keys(state.questionnaires[state.currentTemplateName]['data']).forEach((fieldId) => {
        if (state.questionnaires[state.currentTemplateName]['data'][fieldId]['fieldName'] === fielName) {
          state.selectedQuestionnaireField = fieldId
        }
      })
    },

    setCurrentLocale (state, locale) {
      state.currentLocale = locale
    },

    setFieldEditMode (state, mode) {
      state.editingFields = mode
    },

    setShowBottomMenu (state, show) {
      state.showBottomMenu = show
    },

    setTemplates (state, templates) {
      state.templates = templates
    },

    setTemplateFieldPage (state, fieldData) {
      let templatePages = state.templates[state.currentTemplateName].pages
      if (templatePages === undefined) return

      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        templatePages[pageId].forEach((field, index) => {
          if (field === null) return
          if (field.id === fieldData.id) {
            templatePages[pageId][index] = fieldData
          }
        })
      })
      state.templates[state.currentTemplateName].pages = templatePages
    },

    setCurrentTemplateData (state, template) {
      state.templates[state.currentTemplateName] = template
    },

    setQuestionnaireFieldSelectedEmpty (state) {
      state.selectedQuestionnaireField = ''
    },

    setTemplateFieldQuestionText (state, fieldData) {
      let tmp = state.templates
      if (fieldData.index === undefined) return
      tmp[state.currentTemplateName]['pages'][fieldData.page][fieldData.index]['questionTitle'] = fieldData.title
      tmp[state.currentTemplateName]['pages'][fieldData.page][fieldData.index]['questionHelp'] = fieldData.helpText
    },

    setCurrentTemplateField (state, fieldData) {
      let tmp = state.templates
      tmp[state.currentTemplateName]['pages'][fieldData.page][fieldData.index] = fieldData.data
      state.templates = tmp
    },

    setTemplateField (state, fieldData) {
      let tmp = state.templates
      let onlyField = false

      tmp[fieldData.templateName]['pages'][fieldData.page].forEach((field, index) => {
        if (field !== null) {
          if (field.id === fieldData.fieldId) {
            if (onlyField === false) {
              tmp[fieldData.templateName]['pages'][fieldData.page][index] = fieldData.data

              onlyField = true
            } else {
              tmp[fieldData.templateName]['pages'][fieldData.page].splice(index, 1)
            }
          }
        } else {
          tmp[fieldData.templateName]['pages'][fieldData.page].splice(index, 1)
        }
      })
      state.templates = tmp
    },

    addTemplate (state, templateData) {
      let tmp = state.templates
      tmp[templateData.id] = templateData.data
      state.templates = tmp
    },

    removeTemplate (state, templateId) {
      let tmp = state.templates
      Vue.delete(tmp, templateId)
      state.templates = tmp
    },

    setCurrentFormId (state, formId) {
      state.currentFormId = formId
    },

    setOutputPath (state, path) {
      state.outputPath = path
    },

    setPracticeAreas (state, practiceAreas) {
      state.practiceAreas = practiceAreas
    },

    setFormRoles (state, roles) {
      state.formRoles = roles.sort((a, b) => {
        var nameA = a.name.toUpperCase() // ignore upper and lowercase
        var nameB = b.name.toUpperCase() // ignore upper and lowercase
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      state.formRoles.unshift({
        name: 'None'
      })
    },

    setForms (state, forms) {
      state.forms = forms
    },

    setCurrentTemplateName (state, templateName) {
      state.currentTemplateName = templateName
    },

    setCurrentTemplate (state, templateName) {
      state.currentTemplate = state.templates[templateName]
    },

    addForm (state, formData) {
      state.forms.push(formData)
    },

    setState (state, stateData) {
      state = stateData
    },

    setSelected (state, selectedData) {
      state.annotations[selectedData['index']]['selected'] = selectedData['val']
    },

    setLastSaved (state, timestamp) {
      state.lastSaved = timestamp
    },

    setAnnotations (state, annotations) {
      state.annotations = annotations
    },

    setShowAnnotations (state, show) {
      state.showAnnotations = show
    },

    setAnnotationDataKey (state, annotationData) {
      let tmp = state.annotations
      tmp[annotationData.index]['data'][annotationData.key] = annotationData.value
      state.annotations = tmp
    },

    setAnnotationData (state, annotationData) {
      let tmp = state.annotations
      tmp[annotationData.index]['data'] = annotationData.data
      state.annotations = tmp
    },

    setAnnotationPosition (state, annotationData) {
      let tmp = state.annotations
      tmp[annotationData.index]['x'] = annotationData.pos.x
      tmp[annotationData.index]['y'] = annotationData.pos.y
      state.annotations = tmp
    },

    setAnnotationSize (state, annotationData) {
      let tmp = state.annotations
      tmp[annotationData.index]['width'] = annotationData.size.width
      tmp[annotationData.index]['height'] = annotationData.size.height
      state.annotations = tmp
    },

    setAnnotationRotation (state, rotationData) {
      let tmp = state.annotations
      tmp[rotationData.index]['rotation'] = rotationData.amount
      state.annotations = tmp
    },

    addAnnotation (state, annotation) {
      let tmp = state.annotations
      tmp.push(annotation)
      state.annotations = tmp
    },

    removeAnnotation (state, index) {
      state.annotations.splice(index, 1)
    },

    setDocumentPageAnnotations (state, annotationData) {
      let tmp = state.documentFields
      tmp[annotationData.index]['pageAnnotations'] = annotationData.data
      state.documentFields = tmp
    },

    setPageWidth (state, width) {
      state.pageWidth = width
    },

    setPageHeight (state, height) {
      state.pageHeight = height
    },

    setPageScale (state, scale) {
      state.pageScale = scale
    },

    setFontSize (state, size) {
      state.fontSize = size
    },

    setTotalPages (state, total) {
      state.totalPages = total
    },

    setCurrentPage (state, pageNum) {
      state.fileCurrentPage = pageNum
    },

    setDisablePageNavigation (state, disable) {
      state.disablePageNavigation = disable
    },

    setDrawAnnotations (state, draw) {
      state.drawingAnnotation = draw
    },

    toggleAssigningIndexes (state) {
      state.assigningIndexes = !state.assigningIndexes
    },

    setAssigningIndexes (state, assign) {
      state.assigningIndexes = assign
    },

    setShowFields (state, show) {
      state.showFields = show
    },

    toggleShowFields (state) {
      state.showFields = !state.showFields
    },

    setShowPageList (state, show) {
      state.showPageList = show
    },

    toggleShowPageList (state) {
      state.showPageList = !state.showPageList
    },

    setShowAnnotationMenu (state, show) {
      state.showAnnotationMenu = show
    },

    toggleDragIndex (state) {
      state.dragIndex = !state.dragIndex
    },

    toggleMultipleSelect (state) {
      state.multipleSelect = !state.multipleSelect
    },

    setDragIndex (state, index) {
      state.dragIndex = index
    },

    setMultipleSelect (state, index) {
      state.multipleSelect = index
    },

    setTabOrder (state, fieldData) {
      state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach((field, index) => {
        if (field.id === fieldData.id) {
          let tmp = state.templates
          tmp[state.currentTemplateName]['pages'][state.fileCurrentPage][index]['tabOrder'] = fieldData.index
          state.templates = tmp
          return
        }
      })
    },

    setQuestionnaires (state, questionnaires) {
      state.questionnaires = {}
      state.questionnaires = Object.assign({}, state.questionnaires, questionnaires)
    },

    setQuestionnaireFields (state, questionnaireFields) {
      state.questionnaires[state.currentTemplateName].data = {}
      state.questionnaires[state.currentTemplateName].data = Object.assign({}, state.questionnaires[state.currentTemplateName].data, questionnaireFields)
    },

    addQuestionnaire (state, questionnaireData) {
      state.questionnaires[questionnaireData.index] = questionnaireData.data
    },

    setWidgets (state, widgets) {
      state.widgets = widgets
    },

    updateWidget (state, widgetData) {
      let widgets = state.widgets

      widgets.forEach((widget, index) => {
        if (widget._id === widgetData.widgetId) {
          widgets[index].newValue = widgetData.newData
          return
        }
      })

      state.widgets = widgets
    },

    setFieldGroups (state, fieldGroups) {
      state.templates[state.currentTemplateName]['checkboxGroups'] = fieldGroups
    },

    setCheckboxGroups (state, checkboxGroups) {
      state.templates[state.currentTemplateName]['chGroups'] = checkboxGroups
    },

    setFieldGroupFields (state, dataGroup) {
      state.templates[state.currentTemplateName]['checkboxGroups'][dataGroup.nameGroup].fields = {}
      state.templates[state.currentTemplateName]['checkboxGroups'][dataGroup.nameGroup].fields = dataGroup.fields
      let questionnaireFields = state.questionnaires[state.currentTemplateName].data
      Object.keys(questionnaireFields).forEach(fieldId => {
        if (questionnaireFields[fieldId].fieldName === dataGroup.nameGroup) questionnaireFields[fieldId].checkboxes = dataGroup.fields
      })

      state.questionnaires[state.currentTemplateName].data = questionnaireFields
    },

    setCheckboxGroupFields (state, dataGroup) {
      state.templates[state.currentTemplateName]['chGroups'][dataGroup.nameGroup].checkboxes = dataGroup.checkboxes
    },

    addFieldGroup (state, groupData) {
      if (typeof state.templates[state.currentTemplateName]['checkboxGroups'] === 'undefined' || state.templates[state.currentTemplateName]['checkboxGroups'] === null) state.templates[state.currentTemplateName]['checkboxGroups'] = {}
      groupData.data['fieldId'] = groupData.index
      state.templates[state.currentTemplateName]['checkboxGroups'][groupData.index] = groupData.data
    },

    addCheckboxGroup (state, groupData) {
      if (typeof state.templates[state.currentTemplateName]['chGroups'] === 'undefined' || state.templates[state.currentTemplateName]['chGroups'] === null) state.templates[state.currentTemplateName]['chGroups'] = {}
      groupData.data['fieldId'] = groupData.index
      state.templates[state.currentTemplateName]['chGroups'][groupData.index] = groupData.data
    },

    addFieldToGroup (state, fieldData) {
      let tmpTemplate = state.templates[state.currentTemplateName]
      let tmpQuestionnaireFields = state.questionnaires[state.currentTemplateName].data
      if (tmpTemplate['checkboxGroups'][fieldData.index]['fields'] === undefined) {
        tmpTemplate['checkboxGroups'][fieldData.index].fields = {}
      }
      tmpTemplate['checkboxGroups'][fieldData.index]['fields'][fieldData.fieldId] = fieldData.dataField
      Object.keys(tmpQuestionnaireFields).forEach(fieldId => {
        if (tmpQuestionnaireFields[fieldId].fieldName === fieldData.index) {
          tmpQuestionnaireFields[fieldId].checkboxes[fieldData.fieldId] = fieldData.dataField
        }
        if (tmpQuestionnaireFields[fieldId].fieldName === fieldData.fieldId) delete tmpQuestionnaireFields[fieldId]
      })
      state.templates[state.currentTemplateName] = tmpTemplate
      state.questionnaires[state.currentTemplateName].data = tmpQuestionnaireFields
    },

    addCheckboxToGroup (state, fieldData) {
      let tmpTemplate = state.templates[state.currentTemplateName]
      if (tmpTemplate['chGroups'][fieldData.index]['checkboxes'] === undefined) {
        tmpTemplate['chGroups'][fieldData.index].checkboxes = {}
      }
      tmpTemplate['chGroups'][fieldData.index]['checkboxes'][fieldData.fieldId] = fieldData.dataField

      state.templates[state.currentTemplateName] = tmpTemplate
    },

    removeFieldFromGroup (state, fieldData) {
      let tmpTemplate = state.templates[state.currentTemplateName]
      delete tmpTemplate['checkboxGroups'][fieldData.index]['fields'][fieldData.fieldId]
      let questionnaire = state.questionnaires[state.currentTemplateName]['data']
      Object.keys(questionnaire).forEach(field => {
        if (questionnaire[field].fieldName === fieldData.index) {
          Object.keys(questionnaire[field].checkboxes).forEach(fieldName => {
            if (fieldData.fieldId === fieldName) delete questionnaire[field].checkboxes[fieldName]
          })
          if (Object.keys(questionnaire[field].checkboxes).length === 0) delete questionnaire[field]
        }
      })
      if (Object.keys(tmpTemplate['checkboxGroups'][fieldData.index]['fields']).length === 0) {
        delete tmpTemplate['checkboxGroups'][fieldData.index]
      }
      state.templates[state.currentTemplateName] = Object.assign({}, state.templates[state.currentTemplateName], tmpTemplate)
      state.questionnaires[state.currentTemplateName]['data'] = Object.assign({}, state.questionnaires[state.currentTemplateName]['data'], questionnaire)
    },

    removeCheckboxFromGroup (state, fieldData) {
      let tmpTemplate = state.templates[state.currentTemplateName]
      delete tmpTemplate['chGroups'][fieldData.index]['checkboxes'][fieldData.fieldId]

      if (Object.keys(tmpTemplate['chGroups'][fieldData.index]['checkboxes']).length === 0) {
        delete tmpTemplate['chGroups'][fieldData.index]
      }
      state.templates[state.currentTemplateName] = Object.assign({}, state.templates[state.currentTemplateName], tmpTemplate)
    },

    editFieldGroup (state, groupData) {
      let tmpTemplate = state.templates[state.currentTemplateName]
      let tmpQuestionnaireFields = state.questionnaires[state.currentTemplateName].data
      if (groupData.name !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['name'] = groupData.name
      if (groupData.label !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['title'] = groupData.label
      if (groupData.help !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['desc'] = groupData.help
      if (groupData.prefix !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['prefix'] = groupData.prefix
      if (groupData.tabOrder !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['tabOrder'] = groupData.tabOrder
      if (groupData.indent !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['indent'] = groupData.indent
      if (groupData.abQuestion !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['abQuestion'] = groupData.abQuestion
      if (groupData.tags !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['tags'] = groupData.tags
      if (groupData.tagVisible !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['tagVisible'] = groupData.tagVisible
      if (groupData.page !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['page'] = groupData.page
      if (groupData.maxChecked !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['maxChecked'] = groupData.maxChecked
      if (groupData.checkboxes !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['fields'] = groupData.checkboxes
      if (groupData.watchers !== undefined) tmpTemplate['checkboxGroups'][groupData.index]['watchers'] = groupData.watchers
      state.templates[state.currentTemplateName] = tmpTemplate
      Object.keys(tmpQuestionnaireFields).forEach(fieldId => {
        if (tmpQuestionnaireFields[fieldId].fieldName === groupData.index) {
          if (groupData.name !== undefined) tmpQuestionnaireFields[fieldId].name = groupData.name
          if (groupData.label !== undefined) tmpQuestionnaireFields[fieldId].title = groupData.label
          if (groupData.help !== undefined) tmpQuestionnaireFields[fieldId].desc = groupData.help
          if (groupData.prefix !== undefined) tmpQuestionnaireFields[fieldId].prefix = groupData.prefix
          if (groupData.indent !== undefined) tmpQuestionnaireFields[fieldId].indent = groupData.indent
          if (groupData.abQuestion !== undefined) tmpQuestionnaireFields[fieldId].abQuestion = groupData.abQuestion
          if (groupData.tags !== undefined) tmpQuestionnaireFields[fieldId].tags = groupData.tags
          if (groupData.tagVisible !== undefined) tmpQuestionnaireFields[fieldId].tagVisible = groupData.tagVisible
          if (groupData.page !== undefined) tmpQuestionnaireFields[fieldId].page = groupData.page
          if (groupData.maxChecked !== undefined) tmpQuestionnaireFields[fieldId].maxChecked = groupData.maxChecked
          if (groupData.watchers !== undefined) tmpQuestionnaireFields[fieldId].watchers = groupData.watchers
        }
      })
      state.questionnaires[state.currentTemplateName].data = tmpQuestionnaireFields
    },

    editCheckboxGroup (state, groupData) {
      let tmpTemplate = state.templates[state.currentTemplateName]
      tmpTemplate['chGroups'][groupData.index]['name'] = groupData.name
      tmpTemplate['chGroups'][groupData.index]['title'] = groupData.label
      tmpTemplate['chGroups'][groupData.index]['desc'] = groupData.help
      state.templates[state.currentTemplateName] = tmpTemplate
    },

    editFieldGroupFieldLabel (state, groupData) {
      let tmpTemplate = state.templates[state.currentTemplateName]
      let tmpQuestionnaireFields = state.questionnaires[state.currentTemplateName].data
      tmpTemplate['checkboxGroups'][groupData.index]['fields'][groupData.fieldId].label = groupData.fieldLabel
      state.templates[state.currentTemplateName] = tmpTemplate
      Object.keys(tmpQuestionnaireFields).forEach(fieldId => {
        if (tmpQuestionnaireFields[fieldId].fieldName === groupData.index) {
          Object.keys(tmpQuestionnaireFields[fieldId].checkboxes).forEach(fieldName => {
            if (fieldName === groupData.fieldId) {
              tmpQuestionnaireFields[fieldId].checkboxes[fieldName].translations.en.label = groupData.fieldLabel
              tmpQuestionnaireFields[fieldId].checkboxes[fieldName].translations.en.text = groupData.fieldDesc
            }
          })
        }
      })
    },

    removeFieldGroup (state, groupId) {
      let tmpTemplate = state.templates[state.currentTemplateName]
      delete tmpTemplate['checkboxGroups'][groupId]
      state.templates[state.currentTemplateName] = tmpTemplate
      let questionnaire = state.questionnaires[state.currentTemplateName]['data']
      Object.keys(questionnaire).forEach(field => {
        if (questionnaire[field].fieldName === groupId) delete questionnaire[field]
      })
      state.questionnaires[state.currentTemplateName]['data'] = questionnaire
    },

    removeCheckboxGroup (state, groupId) {
      let tmpTemplate = state.templates[state.currentTemplateName]
      delete tmpTemplate['chGroups'][groupId]
      state.templates[state.currentTemplateName] = tmpTemplate
    },

    removeFieldGroupFromQuestionnaire (state, groupId) {
      let questionnaire = state.questionnaires[state.currentTemplateName]['data']
      state.templates[state.currentTemplateName].checkboxGroups[groupId].hide = true

      Object.keys(questionnaire).forEach(field => {
        if (questionnaire[field].fieldName === groupId) delete questionnaire[field]
      })
      state.questionnaires[state.currentTemplateName]['data'] = questionnaire
    },

    setGroupFieldMaxChecked (state, fieldData) {
      for (let index = 0; index < Object.keys(state.questionnaires[state.currentTemplateName].data).length; index++) {
        let dIndex = Object.keys(state.questionnaires[state.currentTemplateName].data)[index]
        const field = JSON.parse(JSON.stringify(state.questionnaires[state.currentTemplateName].data[dIndex]))
        if (field.fieldName === fieldData.index) {
          let tmpQuestionnaire = state.questionnaires[state.currentTemplateName]
          tmpQuestionnaire['data'][dIndex]['maxChecked'] = fieldData.maxChecked
          state.questionnaires[state.currentTemplateName] = tmpQuestionnaire
        }
      }
    },

    setCheckboxGroupCheck (state, payload) {
      let templateCurrentPage = state.templates[state.currentTemplateName].pages[state.fileCurrentPage]
      let chGroups = state.templates[state.currentTemplateName].chGroups
      let checkboxNames = []

      if (payload.chGroupKey !== null && payload.chGroupKey !== undefined) {
        Object.keys(chGroups[payload.chGroupKey].checkboxes).forEach(checkboxId => {
          if (payload.checked && payload.id !== checkboxId) {
            chGroups[payload.chGroupKey].checkboxes[checkboxId].value = ''

            checkboxNames.push(checkboxId)
          }
        })

        state.templates[state.currentTemplateName].chGroups = chGroups
      }

      templateCurrentPage.forEach((checkbox, index) => {
        if (checkbox !== null && checkbox.id === payload.id) {
          if (payload.checked) {
            checkbox.value = 'on'
          } else {
            checkbox.value = ''
          }

          templateCurrentPage[index] = checkbox
        } else if (checkbox !== null && checkboxNames.indexOf(checkbox.id) !== -1) {
          checkbox.value = ''

          templateCurrentPage[index] = checkbox
        }
      })

      state.templates[state.currentTemplateName].pages[state.fileCurrentPage] = templateCurrentPage
    },

    orderSectionField (state, newId) {
      let newData = []
      let indiceSection = false
      let questionnaireFields = state.questionnaires[state.currentTemplateName].data
      if (state.selectedQuestionnaireField === '') return
      let sectionField = questionnaireFields[newId]
      delete questionnaireFields[newId]
      Object.keys(questionnaireFields).forEach((fieldId) => {
        if (questionnaireFields[fieldId].fieldName === questionnaireFields[state.selectedQuestionnaireField].fieldName && indiceSection === false) {
          newData.push(sectionField)
          newData.push(state.questionnaires[state.currentTemplateName].data[state.selectedQuestionnaireField])
          indiceSection = true
        } else {
          newData.push(state.questionnaires[state.currentTemplateName].data[fieldId])
        }
      })
      if (indiceSection === false) newData.push(sectionField)

      let objFields = {}

      newData.forEach((field, index) => {
        objFields[index + '-' + Math.random().toString(36).split('.')[1]] = field
      })

      state.questionnaires[state.currentTemplateName]['data'] = objFields
      state.selectedQuestionnaireField = ''
    },

    addSectionField (state, fieldData) {
      const newIndex = Object.keys(state.questionnaires[state.currentTemplateName]['data']).length + '-' + Math.random().toString(36).split('.')[1]
      let newField = {
        type: 'section',
        fieldName: newIndex,
        state: 'OK',
        originalValue: fieldData.label,
        newValue: '',
        itemId: 23,
        model: '',
        deleted: false,
        approved: true,
        editable: true,
        subSection: fieldData.subSection,
        values: [],
        page: state.questionnaires[state.currentTemplateName].data[state.selectedQuestionnaireField].page,
        tabOrder: (state.questionnaires[state.currentTemplateName].data[state.selectedQuestionnaireField].tabOrder) - 1,
        title: fieldData.index,
        desc: 'Default inline help text',
        prefix: fieldData.prefix
      }
      state.questionnaires[state.currentTemplateName]['data'][newIndex] = newField
      this.commit('orderSectionField', newIndex)
    },

    removeSection (state, fieldId) {
      let tmpQuestionnaire = state.questionnaires[state.currentTemplateName].data

      if (tmpQuestionnaire[fieldId] !== undefined) delete tmpQuestionnaire[fieldId]
      else {
        Object.keys(tmpQuestionnaire).forEach(fieldKey => {
          if (tmpQuestionnaire[fieldKey].fieldName === fieldId) {
            delete tmpQuestionnaire[fieldKey]
          }
        })
      }

      state.questionnaires[state.currentTemplateName].data = Object.assign({}, state.questionnaires[state.currentTemplateName].data, tmpQuestionnaire)
    },

    editSectionField (state, fieldData) {
      let tmpQuestionnaire = state.questionnaires[state.currentTemplateName]
      tmpQuestionnaire['checkboxGroups'][fieldData.index]['name'] = fieldData.data
      state.questionnaires[state.currentTemplateName] = tmpQuestionnaire
    },

    changeInlineHelp (state, dataInlineHelp) {
      let questionnaireFields = state.questionnaires[state.currentTemplateName]['data']
      if (questionnaireFields[dataInlineHelp.questionnaireId] !== undefined) {
        if (questionnaireFields[dataInlineHelp.questionnaireId].checkboxes) {
          Object.keys(questionnaireFields[dataInlineHelp.questionnaireId].checkboxes).forEach(fieldName => {
            if (fieldName === dataInlineHelp.name) {
              if (questionnaireFields[dataInlineHelp.questionnaireId].checkboxes[fieldName].translations === undefined) {
                let translations = {}
                let en = {}
                en.label = dataInlineHelp.label
                en.text = dataInlineHelp.inlineHelp
                translations.en = en
                questionnaireFields[dataInlineHelp.questionnaireId].checkboxes[fieldName].translations = translations
              }
              questionnaireFields[dataInlineHelp.questionnaireId].checkboxes[fieldName].translations.en.label = dataInlineHelp.label
              questionnaireFields[dataInlineHelp.questionnaireId].checkboxes[fieldName].translations.en.text = dataInlineHelp.inlineHelp
            }
          })
        } else if (questionnaireFields[dataInlineHelp.questionnaireId].type !== 'section') {
          questionnaireFields[dataInlineHelp.questionnaireId].title = dataInlineHelp.label
          questionnaireFields[dataInlineHelp.questionnaireId].desc = dataInlineHelp.inlineHelp
        }
      } else {
        Object.keys(questionnaireFields).forEach(fieldId => {
          if (questionnaireFields[fieldId].fieldName === dataInlineHelp.name) {
            questionnaireFields[fieldId].title = dataInlineHelp.label
            questionnaireFields[fieldId].desc = dataInlineHelp.inlineHelp
          }
        })
      }
      let templatePages = state.templates[state.currentTemplateName]['pages']
      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        templatePages[pageId].forEach((pageData, index) => {
          if (pageData === null || pageData === undefined) return
          if (pageData.name === dataInlineHelp.name) {
            if (pageData.translations) {
              let en = {
                label: dataInlineHelp.label,
                text: dataInlineHelp.inlineHelp
              }
              pageData['translations'].en = en
            }
            pageData.questionHelp = dataInlineHelp.inlineHelp
            templatePages[pageId][index] = pageData
          }
        })
      })

      state.templates[state.currentTemplateName]['pages'] = templatePages
      state.questionnaires[state.currentTemplateName]['data'] = questionnaireFields
    },

    saveInlineHelpDb: (state) => {
      let postData = {
        questionnaireId: state.questionnaires[state.currentTemplateName]._id,
        newData: state.questionnaires[state.currentTemplateName]
      }
      Vue.axios.post(state.apiUrl + 'questionnaire/update', postData).then(response => {
        if (response.data.success) {
          return
        }
      })
    },

    deleteExistOnFieldGroups: (state, fieldName) => {
      if (state.templates[state.currentTemplateName]['checkboxGroups'] === undefined || state.templates[state.currentTemplateName]['checkboxGroups'] === null) return
      let questionnaireFields = state.questionnaires[state.currentTemplateName].data
      Object.keys(state.templates[state.currentTemplateName]['checkboxGroups']).forEach(group => {
        Object.keys(state.templates[state.currentTemplateName]['checkboxGroups'][group]['fields']).forEach(checkbox => {
          if (checkbox === fieldName) {
            delete state.templates[state.currentTemplateName]['checkboxGroups'][group]['fields'][checkbox]
            Object.keys(questionnaireFields).forEach(fieldId => {
              if (questionnaireFields[fieldId].checkboxes) {
                Object.keys(questionnaireFields[fieldId].checkboxes).forEach(fieldGroupFieldName => {
                  if (fieldGroupFieldName === fieldName) delete questionnaireFields[fieldId].checkboxes[fieldGroupFieldName]
                })
                if (Object.keys(questionnaireFields[fieldId].checkboxes).length === 0) delete questionnaireFields[fieldId]
              }
            })
          }
          if (Object.keys(state.templates[state.currentTemplateName]['checkboxGroups'][group]['fields']).length === 0) {
            delete state.templates[state.currentTemplateName]['checkboxGroups'][group]
          }
        })
      })
      state.questionnaires[state.currentTemplateName].data = questionnaireFields
    },

    deleteExistOnCheckboxGroups: (state, fieldName) => {
      if (state.templates[state.currentTemplateName]['chGroups'] === undefined || state.templates[state.currentTemplateName]['chGroups'] === null) return

      Object.keys(state.templates[state.currentTemplateName]['chGroups']).forEach(group => {
        Object.keys(state.templates[state.currentTemplateName]['chGroups'][group]['checkboxes']).forEach(checkbox => {
          if (checkbox === fieldName) {
            delete state.templates[state.currentTemplateName]['chGroups'][group]['checkboxes'][checkbox]
          }

          if (Object.keys(state.templates[state.currentTemplateName]['chGroups'][group]['checkboxes']).length === 0) {
            delete state.templates[state.currentTemplateName]['chGroups'][group]
          }
        })
      })
    },

    setMessageWidgetData (state, foundWidget) {
      if (state.questionnaires[state.currentTemplateName] === undefined) return
      if (state.questionnaires[state.currentTemplateName]['properties'] === undefined) {
        let widgetData = {}
        let message = {}
        message = {
          message: ''
        }
        widgetData[foundWidget.fieldName] = message
        let properties = {
          widgetData: widgetData
        }

        state.questionnaires[state.currentTemplateName].properties = properties
      } else {
        let widgetData = state.questionnaires[state.currentTemplateName]['properties']['widgetData']

        let indiceWidget = 0
        Object.keys(widgetData).forEach(nameWidget => {
          if (nameWidget === foundWidget.fieldName) indiceWidget++
        })
        if (indiceWidget === 0) {
          let message = {}
          message = {
            message: ''
          }
          state.questionnaires[state.currentTemplateName].properties['widgetData'][foundWidget.fieldName] = message
        }
      }
    },
    saveMsgWidget (state, dataWidget) {
      state.widgets.forEach((widget, index) => {
        state.widgets[index]['model'].forEach(model => {
          if (model === dataWidget.model) {
            let widgetData = state.questionnaires[state.currentTemplateName]['properties']['widgetData']
            Object.keys(widgetData).forEach((widgetId) => {
              if (widget.fieldName === widgetId) state.questionnaires[state.currentTemplateName]['properties']['widgetData'][widgetId].message = dataWidget.msg
            })
          }
        })
      })
    },

    updatePrefixTemplate (state, data) {
      let templatePages = state.templates[state.currentTemplateName]['pages']
      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        templatePages[pageId].forEach((field, index) => {
          if (data.fieldName === field.name) {
            field.prefix = data.prefix
            templatePages[pageId][index] = field
          }
        })
      })
      state.templates[state.currentTemplateName]['pages'] = templatePages
    },

    updatePrefixQuestionnaire (state, data) {
      if (
        state.questionnaires[state.currentTemplateName] &&
        state.questionnaires[state.currentTemplateName] !== null
      ) {
        let questionnaireFields = state.questionnaires[state.currentTemplateName]['data']
        Object.keys(questionnaireFields).forEach(fieldIndex => {
          if (data.fieldName === questionnaireFields[fieldIndex].fieldName) {
            questionnaireFields[fieldIndex].prefix = data.prefix
          }
        })
        state.questionnaires[state.currentTemplateName]['data'] = questionnaireFields
      }
    },

    updateModelTemplate (state, data) {
      let templatePages = state.templates[state.currentTemplateName]['pages']
      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        templatePages[pageId].forEach((field, index) => {
          if (data.fieldName === field.name) {
            field.model = data.model
            templatePages[pageId][index] = field
          }
        })
      })
      state.templates[state.currentTemplateName]['pages'] = templatePages
    },

    updateModelQuestionnaire (state, data) {
      let questionnaireFields = state.questionnaires[state.currentTemplateName]['data']
      Object.keys(questionnaireFields).forEach(fieldIndex => {
        if (data.fieldName === questionnaireFields[fieldIndex].fieldName) {
          questionnaireFields[fieldIndex].model = data.model
        }
      })
      state.questionnaires[state.currentTemplateName]['data'] = questionnaireFields
    },

    setTranslation (state) {
      let templatePages = state.templates[state.currentTemplateName]['pages']

      if (Object.keys(templatePages).length === 0) return

      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        if (templatePages[pageId].length === 0) return

        templatePages[pageId].forEach((fieldPage, index) => {
          if (fieldPage === null || fieldPage === undefined) return
          if (!fieldPage.translations || fieldPage.translations === null) {
            let en = {
              label: fieldPage.name,
              text: fieldPage.name
            }
            fieldPage.translations = {}
            fieldPage.translations.en = en
            templatePages[pageId][index] = fieldPage
          }
          if (!fieldPage.importedInlineHelp || fieldPage.importedInlineHelp === null) {
            fieldPage.importedInlineHelp = {}
            fieldPage.importedInlineHelp.en = fieldPage.translations.en
            templatePages[pageId][index] = fieldPage
          }
        })
      })
      state.templates[state.currentTemplateName]['pages'] = templatePages
    },

    setFieldPage (state) {
      let templatePages = state.templates[state.currentTemplateName]['pages']

      if (Object.keys(templatePages).length === 0) return

      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        if (templatePages[pageId].length === 0) return

        templatePages[pageId].forEach((fieldPage, index) => {
          if (fieldPage === null || fieldPage === undefined) return
          if (!fieldPage.fieldPage || fieldPage.fieldPage === null) {
            fieldPage.fieldPage = pageId
            templatePages[pageId][index] = fieldPage
          }
        })
      })
      state.templates[state.currentTemplateName]['pages'] = templatePages
    },

    setTranslationForId (state, dataTranslation) {
      let templatePages = state.templates[state.currentTemplateName]['pages']
      let questionnaireFields = state.questionnaires[state.currentTemplateName]['data']
      if (Object.keys(templatePages).length === 0 || Object.keys(questionnaireFields).length === 0 || !dataTranslation.field || !dataTranslation.translation) return

      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        templatePages[pageId].forEach((fieldPage, index) => {
          if (fieldPage === null || fieldPage === undefined) return
          if (fieldPage.name === dataTranslation.field.name) {
            fieldPage.translations = dataTranslation.translation
            templatePages[pageId][index] = fieldPage
          }
        })
      })
      Object.keys(questionnaireFields).forEach(fieldId => {
        if (questionnaireFields[fieldId].fieldName === dataTranslation.field.name) {
          questionnaireFields[fieldId].title = dataTranslation.translation.en.label
          questionnaireFields[fieldId].desc = dataTranslation.translation.en.text
        }
      })
      state.templates[state.currentTemplateName]['pages'] = templatePages
      state.questionnaires[state.currentTemplateName]['data'] = questionnaireFields
    },

    addFieldsToSection (state, dataAddToSection) {
      let questionnaireFields = state.questionnaires[state.currentTemplateName].data
      Object.keys(questionnaireFields).forEach(fieldId => {
        if (fieldId === dataAddToSection.sectionIndex) {
          if (!questionnaireFields[fieldId].fieldsAdded) questionnaireFields[fieldId].fieldsAdded = {}
          Object.keys(dataAddToSection.dataFields).forEach(index => {
            questionnaireFields[fieldId].fieldsAdded[dataAddToSection.dataFields[index].name] = dataAddToSection.dataFields[index].id
          })
        }
      })
      state.questionnaires[state.currentTemplateName].data = questionnaireFields
    },

    setFieldsAddedToSection (state, dataAddToSection) {
      let questionnaireFields = state.questionnaires[state.currentTemplateName].data
      Object.keys(questionnaireFields).forEach(fieldId => {
        if (fieldId === dataAddToSection.sectionIndex) {
          questionnaireFields[fieldId].fieldsAdded = dataAddToSection.dataFields
        }
      })
      state.questionnaires[state.currentTemplateName].data = questionnaireFields
    },

    editSection (state, dataSection) {
      let questionnaireFields = state.questionnaires[state.currentTemplateName].data
      Object.keys(questionnaireFields).forEach(fieldId => {
        if (fieldId === dataSection.index) {
          questionnaireFields[fieldId].fieldName = dataSection.name
          questionnaireFields[fieldId].originalValue = dataSection.label
          questionnaireFields[fieldId].desc = dataSection.help
          questionnaireFields[fieldId].prefix = dataSection.prefix
        }
      })
      state.questionnaires[state.currentTemplateName].data = questionnaireFields
    },

    setPropsFieldGroups (state) {
      let templatesPages = state.templates[state.currentTemplateName].pages
      let templatesGroups = state.templates[state.currentTemplateName].checkboxGroups
      if (templatesGroups === null || templatesGroups === undefined) return
      Object.keys(templatesGroups).forEach(groupName => {
        if (templatesGroups[groupName].fields) {
          Object.keys(templatesGroups[groupName].fields).forEach(fieldName => {
            if (!templatesGroups[groupName].fields[fieldName].tabOrder || templatesGroups[groupName].fields[fieldName].tabOrder === undefined || templatesGroups[groupName].fields[fieldName].tabOrder === null) {
              if (templatesGroups[groupName].fields[fieldName].tabOrder === 0) return
              Object.keys(templatesPages).forEach(pageId => {
                templatesPages[pageId].forEach(field => {
                  if (field.name === fieldName) {
                    templatesGroups[groupName].fields[fieldName] = {}
                    templatesGroups[groupName].fields[fieldName] = field
                  }
                })
              })
            }
            if (!templatesGroups[groupName].fields[fieldName].translations || templatesGroups[groupName].fields[fieldName].translations === undefined || templatesGroups[groupName].fields[fieldName].translations === null) {
              Object.keys(templatesPages).forEach(pageId => {
                templatesPages[pageId].forEach(field => {
                  if (field.name === fieldName) {
                    templatesGroups[groupName].fields[fieldName] = {}
                    templatesGroups[groupName].fields[fieldName] = field
                  }
                })
              })
            }
          })
        }
      })
      state.templates[state.currentTemplateName].pages = templatesPages
      state.templates[state.currentTemplateName].checkboxGroups = templatesGroups
    },
    setQuestionnairePageAndTabOrder (state) {
      if (state.questionnaires[state.currentTemplateName] !== undefined) {
        let questionnaireFields = state.questionnaires[state.currentTemplateName].data
        let templatePages = state.templates[state.currentTemplateName].pages

        let objFields = {}
        questionnaireFields.forEach((field, index) => {
          objFields[index] = field
        })
        Object.keys(objFields).forEach(fieldId => {
          if (objFields[fieldId].type === 'section') return
          if (!objFields[fieldId].page || !objFields[fieldId].tabOrder) {
            Object.keys(templatePages).forEach(pageId => {
              if (templatePages[pageId] === null) return
              templatePages[pageId].forEach(field => {
                if (field !== null && field.name === objFields[fieldId].fieldName) {
                  objFields[fieldId].page = field.fieldPage
                  objFields[fieldId].tabOrder = field.tabOrder
                }
              })
            })
          }
        })

        state.questionnaires[state.currentTemplateName].data = objFields
      }
    },

    cleanMatchedIndexOnWidget (state) {
      let widgets = state.widgets

      widgets.forEach((widget, index) => {
        widget.matchedIndex = []
        widgets[index] = widget
      })

      state.widgets = widgets
    },

    deleteQuestionnaireField (state, fieldName) {
      if (
        state.questionnaires[state.currentTemplateName] &&
        state.questionnaires[state.currentTemplateName] !== null
      ) {
        let questionnaireFields = state.questionnaires[state.currentTemplateName].data

        Object.keys(questionnaireFields).forEach(fieldId => {
          if (questionnaireFields[fieldId] === null || questionnaireFields[fieldId] === undefined) return
          if (questionnaireFields[fieldId].fieldName === fieldName) delete questionnaireFields[fieldId]
        })

        state.questionnaires[state.currentTemplateName].data = questionnaireFields
      }
    },

    updateQuestionnaireField (state, data) {
      if (state.questionnaires[state.currentTemplateName] === undefined) return

      let updatedFieldData = data.dataField

      let questionnaireFields = state.questionnaires[state.currentTemplateName].data

      Object.keys(questionnaireFields).forEach(fieldId => {
        if (questionnaireFields[fieldId] === null || questionnaireFields[fieldId] === undefined) return
        if (questionnaireFields[fieldId].fieldName === data.name) {
          let newField = questionnaireFields[fieldId]
          newField.type = updatedFieldData.type
          newField.model = updatedFieldData.model
          newField.maxCharacter = Number(updatedFieldData.maxCharacter)
          newField.title = updatedFieldData.translations[state.currentLocale]['label']
          newField.desc = updatedFieldData.translations[state.currentLocale]['text']

          if (newField.type === 'textarea') newField.type = 'text'
          else if (newField.type === 'radio') newField.type = 'checkbox'
          else if (newField.type === 'button') newField.type = 'checkbox'
          else if (newField.type === 'select') {
            newField.type = 'combobox'
            newField.values = updatedFieldData.choiceData
          }
          questionnaireFields[fieldId] = newField
        } else if (questionnaireFields[fieldId].checkboxes) {
          Object.keys(questionnaireFields[fieldId].checkboxes).forEach(fieldKey => {
            if (fieldKey === data.name) {
              let newField = questionnaireFields[fieldId].checkboxes[fieldKey]
              newField.type = updatedFieldData.type
              newField.model = updatedFieldData.model
              newField.maxCharacter = Number(updatedFieldData.maxCharacter)
              newField.title = updatedFieldData.translations[state.currentLocale]['label']
              newField.desc = updatedFieldData.translations[state.currentLocale]['text']

              if (newField.type === 'textarea') newField.type = 'text'
              else if (newField.type === 'radio') newField.type = 'checkbox'
              else if (newField.type === 'button') newField.type = 'checkbox'
              else if (newField.type === 'select') {
                newField.type = 'combobox'
                newField.values = updatedFieldData.choiceData
              }
              questionnaireFields[fieldId].checkboxes[fieldKey] = newField
            }
          })
        }
      })

      state.questionnaires[state.currentTemplateName].data = questionnaireFields
    },

    setAuthentication (state, user) {
      state.user = user
    }
  },

  getters: {
    getIfExistFieldOnWidget: (state) => (fieldName) => {
      let widgets = state.widgets

      let isWidget = null

      widgets.forEach(widget => {
        if (widget.matchedIndex === undefined) return
        widget.matchedIndex.forEach(field => {
          if (field.fieldName === fieldName) isWidget = true
        })
      })

      return isWidget
    },

    getMatchedWidgetFields: (state) => (widgetId) => {
      let fields = null
      let widgets = state.widgets

      widgets.forEach(widget => {
        if (widget._id === widgetId) fields = widget.matchedIndex
      })

      return fields
    },

    getIdWidgetGroup: (state) => (fieldName) => {
      let widgets = state.widgets
      let nameWidget = null

      widgets.forEach(widget => {
        if (widget.matchedIndex === undefined) return
        widget.matchedIndex.forEach(widgetField => {
          if (fieldName === widgetField.fieldName) nameWidget = widget._id
        })
      })

      return nameWidget
    },

    getWidgetModels: (state) => (widgetId) => {
      let models = null
      let widgets = state.widgets

      widgets.forEach(widget => {
        if (widget._id === widgetId) models = widget.model
      })

      return models
    },

    getTemplateDataForModel: (state) => (arrayFoundWidget) => {
      let arrayModels = []

      arrayFoundWidget.forEach(foundWidget => {
        foundWidget.matchedModels.forEach(model => {
          arrayModels.push(model)
        })
      })

      let arrayFields = []
      let templatePages = state.templates[state.currentTemplateName].pages
      if (templatePages === undefined || templatePages === null) return

      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        templatePages[pageId].forEach(field => {
          if (field === null || field === undefined) return
          if (field.model === '') return
          if (arrayModels.indexOf(field.model) !== -1) {
            arrayFields.push(field)
          }
        })
      })

      return (arrayFields)
    },

    getSections: (state) => () => {
      let foundSections = {}
      let questionnaireFields = state.questionnaires[state.currentTemplateName].data
      Object.keys(questionnaireFields).forEach(fieldId => {
        if (fieldId === undefined || fieldId === null) return
        if (questionnaireFields[fieldId].type === null || questionnaireFields[fieldId].type === undefined) return
        if (questionnaireFields[fieldId].type === 'section') foundSections[fieldId] = questionnaireFields[fieldId]
      })
      return foundSections
    },

    getAllModels: (state) => () => {
      let templatePages = state.templates[state.currentTemplateName]['pages']
      let dataFields = []

      if (Object.keys(templatePages).length === 0) return

      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        templatePages[pageId].forEach(fieldPage => {
          if (fieldPage === null || fieldPage === undefined || fieldPage.model === null || fieldPage.model === undefined) return
          if (fieldPage.model !== '') dataFields.push(fieldPage)
        })
      })
      return dataFields
    },

    orderFieldsForPage: (state) => (questionnaireFields) => {
      let dataFields = questionnaireFields
      let newDataFields = []
      let objFields = {}
      let tmpTabOrder = -1
      let tmpPage = -1
      let nameInsert = []
      let contFields = 0
      while (newDataFields.length < dataFields.length) {
        contFields++
        questionnaireFields.forEach((field, index) => {
          if (!field.page) {
            dataFields.splice(index, 1)
            return
          } else if (!field.tabOrder) {
            dataFields.splice(index, 1)
            return
          } else {
            if (tmpPage === -1 && nameInsert.indexOf(field.fieldName) === -1) {
              tmpPage = parseInt(field.page)
              tmpTabOrder = field.tabOrder
            }
            if (tmpPage > parseInt(field.page) && nameInsert.indexOf(field.fieldName) === -1) {
              tmpPage = parseInt(field.page)
              tmpTabOrder = field.tabOrder
            }
          }
        })
        questionnaireFields.forEach((field, index) => {
          if (!field.page) dataFields.splice(index, 1)
          else if (!field.tabOrder) dataFields.splice(index, 1)
          else {
            if (tmpPage === parseInt(field.page) && tmpTabOrder > field.tabOrder && nameInsert.indexOf(field.fieldName) === -1) {
              tmpTabOrder = field.tabOrder
            }
          }
        })
        questionnaireFields.forEach((field, index) => {
          if (!field.page) dataFields.splice(index, 1)
          else if (!field.tabOrder) dataFields.splice(index, 1)
          else if (field === null) dataFields.splice(index, 1)
          else {
            if (parseInt(field.page) === tmpPage && field.tabOrder === tmpTabOrder && nameInsert.indexOf(field.fieldName) === -1) {
              newDataFields.push(field)
              nameInsert.push(field.fieldName)
              tmpTabOrder = -1
              tmpPage = -1
            }
          }
        })
        if (contFields > newDataFields.length) newDataFields.push({fieldName: 'null'})
      }
      newDataFields.forEach((field, index) => {
        objFields[index + '-' + Math.random().toString(36).split('.')[1]] = field
      })
      return objFields
    },

    templateFields: (state) => () => {
      let fieldList = []

      for (const page in state.templates[state.currentTemplateName]['pages']) {
        if (state.templates[state.currentTemplateName]['pages'].hasOwnProperty(page)) {
          const fields = state.templates[state.currentTemplateName]['pages'][page]
          fields.forEach(field => {
            field['page'] = page
            fieldList.push(field)
          })
        }
      }

      return fieldList
    },

    formIndex: (state) => (formId) => {
      for (let i = 0; i < state.forms.length; i++) {
        const form = state.forms[i]
        if (form._id === formId) return i
      }
      return null
    },

    templateFieldById: (state) => (fieldId) => {
      let fieldData = {}

      for (const pageIndex in state.templates[state.currentTemplateName]['pages']) {
        if (state.templates[state.currentTemplateName]['pages'].hasOwnProperty(pageIndex)) {
          const page = state.templates[state.currentTemplateName]['pages'][pageIndex]
          if (page === null) continue
          page.forEach(field => {
            if (field === null) return
            if (field.id === fieldId) {
              fieldData = field
              fieldData['fieldPage'] = pageIndex
              return
            }
          })
        }
      }
      return fieldData
    },

    templateField: (state) => (templateName, fieldId, page) => {
      let fieldData = {}
      state.templates[templateName]['pages'][page].forEach((field, index) => {
        if (field.id === fieldId) {
          fieldData = field
          return
        }
      })
      return fieldData
    },

    templateFieldByModel: (state) => (model) => {
      let fieldId = null
      state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach((field, index) => {
        if (field.model === model) {
          fieldId = field.id
        }
      })
      return fieldId
    },

    currentTemplateField: (state) => (fieldId) => {
      let fieldData = {}
      state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach((field, index) => {
        if (field === null) return
        if (field.id === fieldId) {
          fieldData = field
          return
        }
      })
      return fieldData
    },

    templateFieldIndex: (state) => (templateName, fieldId, page) => {
      let fieldIndex = null

      if (state.templates[templateName]['pages'][page] === undefined) return
      state.templates[templateName]['pages'][page].forEach((field, index) => {
        if (field === null) return
        if (field.id === fieldId) fieldIndex = index
      })
      return fieldIndex
    },

    currentTemplateFieldIndex: (state) => (fieldId, page) => {
      let fieldIndex = null
      if (state.templates[state.currentTemplateName]['pages'][page] === undefined) return
      state.templates[state.currentTemplateName]['pages'][page].forEach((field, index) => {
        if (field === null) return
        if (field.id === fieldId) fieldIndex = index
      })
      return fieldIndex
    },

    fieldTooltip: (state) => (page, fieldIndex) => {
      let localization = 'No localization text specified for this language.'
      if (typeof state.templates[state.currentTemplateName]['pages'][page][fieldIndex].translations !== 'undefined' && Object.keys(state.templates[state.currentTemplateName]['pages'][page][fieldIndex].translations).length &&
          typeof state.templates[state.currentTemplateName]['pages'][page][fieldIndex].translations[state.currentLocale] !== 'undefined') {
        localization = state.templates[state.currentTemplateName]['pages'][page][fieldIndex].translations[state.currentLocale]
      }
      let fieldLabel = localization.label
      let fieldText = localization.text
      let fieldTabOrder = state.templates[state.currentTemplateName]['pages'][page][fieldIndex]['tabOrder']
      if (typeof fieldLabel === 'undefined' || !fieldLabel.length) fieldLabel = state.templates[state.currentTemplateName]['pages'][page][fieldIndex]['name']
      if (typeof fieldText === 'undefined' || !fieldText.length) fieldText = 'No help text provided for this language'
      return { name: fieldLabel, text: fieldText, tabOrder: fieldTabOrder }
    },

    templateTabOrder: (state) => (fieldName) => {
      let tabOrder = -1
      state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach((field, index) => {
        if (field === null) return
        if (field.id === fieldName) tabOrder = field.tabOrder
      })
      return tabOrder
    },

    tabOrder: (state) => (fieldData) => {
      let tabOrder = -1
      state.templates[state.currentTemplateName]['pages'][fieldData.pageNum].forEach((field, index) => {
        if (field.id === fieldData.fieldId) {
          tabOrder = field.tabOrder
          return
        }
      })
      return tabOrder
    },

    templateModel: (state) => (fieldName) => {
      let model = ''
      state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].forEach((field, index) => {
        if (field === null) return
        if (field.id === fieldName) model = field.model
      })
      return model
    },

    searchModels: (state) => (targetModel) => {
      let foundModel = {}
      let newTarget = ''
      for (let index = 0; index < targetModel.length; index++) {
        if (isNaN(targetModel.charAt(index))) newTarget += targetModel.charAt(index)
        else newTarget += '#'
      }

      state.models.forEach(model => {
        const computedModel = model.type + model.prefix + model.field
        if (computedModel === newTarget) {
          foundModel = model
          return
        }
      })
      return foundModel
    },

    // tabOrderExists: (state) => (tabOrder) => {
    //   for (const key in state.fields) {
    //     if (state.fields.hasOwnProperty(key)) {
    //       const field = state.fields[key]
    //       if (Number(field['tabOrder']) === Number(tabOrder)) return true
    //     }
    //   }
    //   return false
    // },

    topTabOrder: (state) => () => {
      let top = -1
      for (let i = 0; i < state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage].length; i++) {
        const field = state.templates[state.currentTemplateName]['pages'][state.fileCurrentPage][i]
        if (field['tabOrder'] > top) top = Number(field['tabOrder'])
      }
      return top > -1 ? top : 0
    },

    fileCurrentPage: (state) => () => {
      return state.fileCurrentPage
    },

    pageSvg: (state) => () => {
      console.log(state.outputPath)
      return state.outputPath + '/svg/' + state.fileCurrentPage + '.svg'
    },

    pageScale: (state) => () => {
      return state.pageScale
    },

    fontScale: (state) => () => {
      return state.fontSize * state.pageScale
    },

    fontSize: (state) => () => {
      return state.fontSize
    },

    pageWidth: (state) => () => {
      return state.pageWidth * state.pageScale
    },

    pageHeight: (state) => () => {
      return state.pageHeight * state.pageScale
    },

    totalPages: (state) => () => {
      return state.totalPages
    },

    annotationRotation: (state) => (index) => {
      return state.annotations[index]['rotation']
    },

    pageAnnotations: (state) => (page) => {
      return []
      // if (typeof state.documentFields[page] === 'undefined') return []
      // if (typeof state.documentFields[page]['pageAnnotations'] === 'undefined') return []
      // return state.documentFields[page]['pageAnnotations']
    },

    modelWidget: (state) => (model) => {
      let foundWidget = null
      state.widgets.forEach(widget => {
        if (widget.model.indexOf(model) !== -1) {
          foundWidget = widget
          return
        }
      })
      return foundWidget
    },

    groupFieldNames: (state) => () => {
      let names = {}
      for (const key in state.templates[state.currentTemplateName]['checkboxGroups']) {
        if (state.templates[state.currentTemplateName]['checkboxGroups'].hasOwnProperty(key)) {
          names[key] = state.templates[state.currentTemplateName]['checkboxGroups'][key]['name']
        }
      }
      return names
    },

    chGroupCheckboxNames: (state) => () => {
      let names = {}
      for (const key in state.templates[state.currentTemplateName]['chGroups']) {
        if (state.templates[state.currentTemplateName]['chGroups'].hasOwnProperty(key)) {
          names[key] = state.templates[state.currentTemplateName]['chGroups'][key]['name']
        }
      }
      return names
    },

    groupFields: (state) => () => {
      if (typeof state.templates[state.currentTemplateName]['checkboxGroups'] === 'undefined') return {}
      return state.templates[state.currentTemplateName]['checkboxGroups']
    },

    chGroupFields: (state) => () => {
      if (typeof state.templates[state.currentTemplateName]['chGroups'] === 'undefined') return {}
      return state.templates[state.currentTemplateName]['chGroups']
    },

    fieldGroup: (state) => (fieldId) => {
      let foundKey = null
      for (const key in state.templates[state.currentTemplateName]['checkboxGroups']) {
        if (state.templates[state.currentTemplateName]['checkboxGroups'].hasOwnProperty(key)) {
          const group = state.templates[state.currentTemplateName]['checkboxGroups'][key]
          if (group.fields !== undefined) {
            Object.keys(group.fields).forEach(field => {
              if (field === fieldId) {
                foundKey = key
                return
              }
            })
          }
        }
      }
      return foundKey
    },

    checkboxGroup: (state) => (fieldId) => {
      let foundKey = null
      for (const key in state.templates[state.currentTemplateName]['chGroups']) {
        if (state.templates[state.currentTemplateName]['chGroups'].hasOwnProperty(key)) {
          const group = state.templates[state.currentTemplateName]['chGroups'][key]
          if (group.checkboxes !== undefined) {
            Object.keys(group.checkboxes).forEach(field => {
              if (field === fieldId) {
                foundKey = key
                return
              }
            })
          }
        }
      }
      return foundKey
    },

    fieldGroupMaxFields: (state) => (fieldName) => {
      for (const key in state.questionnaires[state.currentTemplateName].data) {
        if (state.questionnaires[state.currentTemplateName].data.hasOwnProperty(key)) {
          const field = state.questionnaires[state.currentTemplateName].data[key]
          if (field.fieldName === fieldName) {
            return field.maxChecked
          }
        }
      }
      return null
    },

    searchQuestionnaire: (state) => (fieldId) => {
      if (state.questionnaires[state.currentTemplateName] === undefined) return

      let questionnaireField = null
      Object.keys(state.questionnaires[state.currentTemplateName]['data']).forEach((field) => {
        if (state.questionnaires[state.currentTemplateName]['data'][field].fieldName === fieldId) questionnaireField = false
      })
      return questionnaireField
    },

    getTemplateData: (state) => (fieldName) => {
      let template = state.templates[state.currentTemplateName]['pages']
      let fieldData = null
      Object.keys(template).forEach(pageId => {
        if (template[pageId] === null) return
        template[pageId].forEach(field => {
          if (field === null) return
          if (field.name === fieldName) fieldData = field
        })
      })
      return fieldData
    },

    addFieldQuestionnaire: (state) => (field) => {
      if (field === null || state.questionnaires[state.currentTemplateName] === undefined) return
      let newField = {}
      // let existingModels = []
      let newId = Object.keys(state.questionnaires[state.currentTemplateName]['data']).length + '-' + Math.random().toString(36).split('.')[1]
      // if (field.model.length && existingModels.indexOf(field.model) !== -1) return
      newField = {
        type: field.type,
        fieldName: field.id,
        state: 'OK',
        originalValue: typeof field.value !== 'undefined' && field.value.length ? field.value : '',
        newValue: '',
        itemId: 23,
        model: field.model,
        deleted: false,
        approved: true,
        editable: true,
        values: [],
        title: field.id,
        desc: 'Default inline help text',
        tabOrder: field.tabOrder,
        page: field.fieldPage,
        maxCharacter: Number(field.maxCharacter)
      }

      if (field.forceShow !== undefined) newField.forceShow = field.forceShow

      if (field.tagVisible !== undefined) newField.tagVisible = field.tagVisible

      if (typeof field.translations !== 'undefined') {
        if (typeof field.translations[state.currentLocale] !== 'undefined') {
          newField.title = field.translations[state.currentLocale]['label']
          newField.desc = field.translations[state.currentLocale]['text']
        }
      }
      if (newField.type === 'textarea') newField.type = 'text'
      else if (newField.type === 'radio') newField.type = 'checkbox'
      else if (newField.type === 'button') newField.type = 'checkbox'
      else if (newField.type === 'select') {
        newField.type = 'combobox'
        newField.values = field.choiceData
      }

      let tmpQuestionnaires = JSON.parse(JSON.stringify(state.questionnaires))

      tmpQuestionnaires[state.currentTemplateName].data[newId] = newField

      return tmpQuestionnaires
    },

    getInlineHelp: (state) => (dataText) => {
      const validate = require('validate.js')

      const constraints = {
        text: {
          presence: {message: 'is required text'},
          length: {
            minimum: 3
          }
        }
      }
      let validationResults = validate(dataText, constraints)
      if (validationResults) return validationResults
      let objLabel = null
      let label = ''
      let inlineHelp = ''
      let from = null
      let to = null
      if (state.currentTemplateName !== 'global') {
        let arrayText = dataText.text.split(dataText.separator)
        let size = Object.keys(dataText.toLabel).length
        if (size === 1) {
          from = parseInt(dataText.toLabel)
          to = from
        } else {
          from = parseInt(dataText.toLabel.substring(0, 1))
          to = parseInt(dataText.toLabel.substring(2))
        }
        if (from < 1 || to < 1 || from > arrayText.length || from > to) return
        for (let subIndiceArray = from - 1; subIndiceArray < to; subIndiceArray++) {
          if ((subIndiceArray + 1) === to) {
            label = label + arrayText[subIndiceArray]
          } else {
            label = label + arrayText[subIndiceArray] + '.'
          }
        }
        for (let subIndiceArray = to; subIndiceArray < arrayText.length; subIndiceArray++) {
          if ((subIndiceArray + 1) === arrayText.length) {
            inlineHelp = inlineHelp + arrayText[subIndiceArray]
          } else {
            inlineHelp = inlineHelp + arrayText[subIndiceArray] + '.'
          }
        }
        objLabel = {
          label: label,
          inlineHelp: inlineHelp
        }
      }
      return objLabel
    },

    getAllQuestionnaireFileds: (state) => () => {
      let dataAllInlineHelp = []
      let questionnaireFields = state.questionnaires[state.currentTemplateName]['data']
      Object.keys(questionnaireFields).forEach(field => {
        if (questionnaireFields[field].checkboxes) {
          Object.keys(questionnaireFields[field].checkboxes).forEach(fieldName => {
            let fieldData = {
              questionnaireId: field,
              name: fieldName,
              desc: questionnaireFields[field].checkboxes[fieldName].translations.en.text,
              model: questionnaireFields[field].checkboxes[fieldName].model
            }
            dataAllInlineHelp.push(fieldData)
          })
        } else {
          let fieldData = {
            questionnaireId: field,
            name: questionnaireFields[field].fieldName,
            desc: questionnaireFields[field].desc,
            model: questionnaireFields[field].model
          }
          dataAllInlineHelp.push(fieldData)
        }
      })
      return dataAllInlineHelp
    },

    getInlineHelpFromTemplate: (state) => (nameFieldQuestionnaire) => {
      let fieldDescTemplate = null
      let pages = state.templates[state.currentTemplateName]['pages']
      Object.keys(pages).forEach((page) => {
        if (pages[page] === undefined) return
        Object.keys(pages[page]).forEach(field => {
          if (pages[page][field] === null || pages[page][field] === undefined) return
          let nameField = pages[page][field].name
          if (nameField === nameFieldQuestionnaire) {
            if (pages[page][field]['importedInlineHelp'] === undefined || pages[page][field]['importedInlineHelp'] === null) return
            fieldDescTemplate = pages[page][field]['importedInlineHelp']['en']
          }
        })
      })
      return fieldDescTemplate
    },

    getFieldNamesFromFieldGroup: (state) => (groupId) => {
      let nameFields = null
      if (groupId !== undefined && groupId !== null) {
        if (state.templates[state.currentTemplateName]['checkboxGroups'][groupId] === undefined) return
        if (state.templates[state.currentTemplateName]['checkboxGroups'][groupId]['fields'] === undefined) return
        nameFields = Object.keys(state.templates[state.currentTemplateName]['checkboxGroups'][groupId]['fields'])
      }
      return nameFields
    },

    orderFieldGroupFields: (state) => (dataFields) => {
      let arrayTabsOrder = []
      Object.keys(dataFields).forEach(fieldId => {
        arrayTabsOrder.push(dataFields[fieldId].tabOrder)
      })

      let newFields = {}

      while (arrayTabsOrder.length !== 0) {
        let menorTab = Math.min.apply(null, arrayTabsOrder)
        Object.keys(dataFields).forEach(fieldId => {
          if (dataFields[fieldId].tabOrder === menorTab) {
            newFields[dataFields[fieldId].id] = dataFields[fieldId]
          }
        })
        let index = arrayTabsOrder.indexOf(menorTab)
        arrayTabsOrder.splice(index, 1)
      }

      return newFields
    },

    getAllFieldNamesFromTemplate: (state) => () => {
      let nameFields = []
      let templatePages = state.templates[state.currentTemplateName].pages

      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        templatePages[pageId].forEach(field => {
          if (field !== null) {
            nameFields.push(field.id)
          }
        })
      })

      return nameFields
    },

    getFormTags: (state) => () => {
      let tags = []
      let template = state.templates[state.currentTemplateName]

      // Template tags

      let templatePages = template.pages

      Object.keys(templatePages).forEach(pageId => {
        if (templatePages[pageId] === null) return
        templatePages[pageId].forEach(field => {
          if (field !== null && field !== undefined) {
            if (field.tags === undefined) field.tags = []

            field.tags.forEach(tag => {
              let exist = false

              tags.forEach(tagNext => {
                if (tag === tagNext) exist = true
              })

              if (exist === false) tags.push(tag)
            })
          }
        })
      })

      // Checkbox Group tags

      let checkboxGroups = template.checkboxGroups

      if (checkboxGroups !== undefined && checkboxGroups !== null) {
        Object.keys(checkboxGroups).forEach(checkboxGroupKey => {
          if (checkboxGroups[checkboxGroupKey] === null) return

          if (checkboxGroups[checkboxGroupKey].tags === undefined) checkboxGroups[checkboxGroupKey].tags = []

          checkboxGroups[checkboxGroupKey].tags.forEach(tag => {
            let exist = false

            tags.forEach(tagNext => {
              if (tag === tagNext) exist = true
            })

            if (exist === false) tags.push(tag)
          })
        })
      }

      // Questionnaire tags

      if (state.questionnaires[state.currentTemplateName] === undefined) return

      let questionnaireFields = state.questionnaires[state.currentTemplateName].data

      Object.keys(questionnaireFields).forEach(fieldKey => {
        if (questionnaireFields[fieldKey].tags === undefined) return

        questionnaireFields[fieldKey].tags.forEach(tag => {
          let exist = false

          tags.forEach(tagNext => {
            if (tag === tagNext) exist = true
          })

          if (exist === false) tags.push(tag)
        })
      })

      return tags
    },

    getActionTags: (state) => (checkboxGroupId) => {
      let actionTags = []
      let template = state.templates[state.currentTemplateName]

      let checkboxGroups = template.checkboxGroups

      if (checkboxGroups[checkboxGroupId] === null) return

      if (checkboxGroups[checkboxGroupId].actionTags !== undefined) actionTags = checkboxGroups[checkboxGroupId].actionTags

      return actionTags
    },

    isAuthenticated: (state) => state.user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js